import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { Container, Box, Typography, TextField, Button } from "@material-ui/core";
import { toast } from "react-toastify";
import useDb from "../hooks/useDb";
import useUser from "../hooks/useUser";
import useAPI from "../hooks/useAPI";
import Layout from "../components/Layout";
import WorkOffline from "../components/WorkOffline";
import StyledCard from "../components/StyledCard";
const Login = () => {
  const { register, handleSubmit } = useForm();
  const history = useHistory();
  const { user, setUser } = useUser();
  const db = useDb();
  const api = useAPI();

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (user && token) history.push("/app");
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const handleLogin = (data) => {
    api.post("/authentication/login", data)
      .then(async (res) => {
        localStorage.setItem("accessToken", res.data.accessToken);
        await db.users.put(res.data.user);
        setUser(res.data.user);
        history.push("/app");
      })
      .catch((error) => {
        toast.error("Invalid username or password provided");
        console.log("handle login error", error);
      });
  };

  return (
    <Layout title="Login">
      <Container maxWidth="sm">
        <Box mx="auto" mt={10}>
          <form onSubmit={handleSubmit(handleLogin)}>
            <StyledCard px={5}>
              <Box display='flex' flexDirection='column'>
                <Box display='flex' justifyContent='center'>
                  <Typography variant={'h4'}>Log in</Typography>
                </Box>
                <Box width="100%" alignItems='left' display='flex' flexDirection='column' my={1}>
                  <label for="username">Username</label>
                  <TextField name="username" variant="outlined" size="small" inputRef={register} />
                </Box>
                <Box width="100%" alignItems='left' display='flex' flexDirection='column' my={1}>
                  <label for="username">Password</label>
                  <TextField name="password" type="password" variant="outlined" size="small" inputRef={register} />
                </Box>
                <Box justifyContent="flex-end" display="flex" my={1}>
                  <Button type="submit" color="primary" variant="contained">Login</Button>
                </Box>
              </Box>
            </StyledCard>
          </form>
          <StyledCard px={15} py={5}>
            <WorkOffline handleWorkOffline={() => history.push("/app")} />
          </StyledCard>
        </Box>
      </Container>
    </Layout>
  );
};

export default Login;
